import { copyToClipBoard } from "components/dashboard/dataset-info-search/utils";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { useHotkeys } from "react-hotkeys-hook";

const useCopyDataset = (
  isHovered: boolean,
  title: string | undefined,
  identifier: string | undefined
) => {
  useHotkeys(
    "ctrl+c",
    async () => {
      if (isHovered && title) {
        await copyToClipBoard(title);
        easasAlert({ summary: "Copied Dataset tag", detail: title, life: 2500 });
      }
    },
    [title, isHovered]
  );

  useHotkeys(
    "alt+c",
    async () => {
      if (isHovered && identifier) {
        await copyToClipBoard(identifier);
        easasAlert({ summary: "Copied identifier", detail: `${identifier}`, life: 2500 });
      }
    },
    [identifier, isHovered]
  );
};

export default useCopyDataset;
